import * as React from "react";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
const HttpNotificationDetails = ({ notification }) => {
  var _a, _b;
  const { t } = useTranslation("event_notifications");
  const apiKeySet = (_a = notification.config.api_secret) == null ? void 0 : _a.is_set;
  const apiSentAs = notification.config.api_key_as_header ? t("http_details.header") : t("http_details.query_parameter");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("http_details.url"), value: notification.config.url }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("http_details.basic_auth"),
      value: ((_b = notification.config.basic_auth) == null ? void 0 : _b.is_set) ? "******" : null
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("http_details.api_key_sent_as"), value: apiKeySet ? apiSentAs : null }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("http_details.api_key"), value: notification.config.api_key }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("http_details.api_secret"), value: apiKeySet ? "******" : null }));
};
export default HttpNotificationDetails;
